import '@babel/polyfill';
// This polyfills JavaScript’s `Element.closest` so we can use this instead of
// jQuery’s `closest`.
import 'element-closest';

import AccountUtils from './utils/account';
import {JSErrorTracking} from './utils/js-error-tracking';
import { MobileUtil } from './utils/mobile';
import NavigationView from './navigation/view';
import BodyView from './body-view';
import WindowView from './window-view';
import SearchFeedView from './search/feed-view';
import SearchFilterView from './search/filter-view';
import SearchContentView from './search/content-view';
import SearchMobileBarView from './search/mobile-bar-view';
import SearchHeaderView from './search/header-view';
import GenderSplitView from './search/gender-split-view';
import MobileRelatedSearchView from './search/mobile-related-search-view';
import MagazinePostView from './magazine/post-view';
import NewsletterView from './newsletter/view';
import ProductView from './product/view';
import FilterSuggestionsView from './search/filter-suggestions-view';
import ScrollableView from './search/scrollable-main-view';
import HScrollableView from './utils/hscroll';
import FeaturedProducts from './search/featured-products';
import SideNavigationView from './navigation/side-view';
import Newsletter from './newsletter/newsletter';
import {DealView} from "./search/deal-view"

import TabComponent from './account/tabs';

import UserSignupView from './account/signup-view';
import UserSigninView from './account/signin-view';
import UserSignoutView from './account/signout-view';
import UserResetPasswordView from './account/reset-password-view';

import UserLikeView from './account/like-view';
import WishlistView from './account/wishlist-view';
import WeatherTrackingView from './account/weather-tracking-view';

import SettingsUserView from './account/settings-user';
import SettingsEmailView from './account/settings-email';
import SettingsPasswordView from './account/settings-password';
import SettingsDeleteView from './account/settings-delete';
import SettingsNewsletterView from './account/settings-newsletter';

$(() => {

    JSErrorTracking.initializeWrapping();

    // important stuff first
    new BodyView();
    new WindowView();
    new NavigationView();
    new SearchFeedView();
    new SearchFilterView();
    new SearchContentView();
    new SearchMobileBarView();
    new SearchHeaderView();
    new GenderSplitView();
    new MobileRelatedSearchView();
    new ProductView();
    new MagazinePostView();
    new UserLikeView();
    new NewsletterView();
    new FilterSuggestionsView();
    new ScrollableView();
    new WeatherTrackingView();
    new FeaturedProducts();
    
    if(MobileUtil.isApp() && document.querySelector('.js-side-navigation')){
        new SideNavigationView();
    }
    
    $(".js-tabs").each(function() {
        new TabComponent({ el: $(this) });
    });
    
    $(".js-hscroll").each(function() {
        new HScrollableView({ el: $(this) });
    });
    
    $(".js-newsletter").each(function() {
        new Newsletter({ el: $(this) });
    });
    
    $(".magazine-gallery").slick({
        prevArrow: '<button type="button" data-role="none" class="magazine-gallery-arrow-prev" aria-label="previous"><svg class="magazine-gallery-arrow-icon" viewBox="3 0 50 50"><use xlink:href="#icon-arrow-left"></use></svg>Previous</button>',
        nextArrow: '<button type="button" data-role="none" class="magazine-gallery-arrow-next" aria-label="next"><svg class="magazine-gallery-arrow-icon" viewBox="0 0 50 50"><use xlink:href="#icon-arrow-right"></use></svg>Next</button>',
        adaptiveHeight: true,
        lazyLoad: 'ondemand'
    });
    
    if (AccountUtils.isLoggedIn()) {
        new UserSignoutView();
        $('.js-wishlist').each(function() { new WishlistView({ el: $(this) }); });
        $('.js-settings-user').each(function() { new SettingsUserView({ el: $(this) }); });
        $('.js-settings-email').each(function() { new SettingsEmailView({ el: $(this) }); });
        $('.js-settings-password').each(function() { new SettingsPasswordView({ el: $(this) }); });
        $('.js-settings-newsletter').each(function() { new SettingsNewsletterView({ el: $(this) }); });
        $('.js-settings-delete').each(function() { new SettingsDeleteView({ el: $(this) }); });
    } else {
        $('.js-signin-box').each(function() { new UserSigninView({ el: $(this) }); });
        $('.js-signup-box').each(function() { new UserSignupView({ el: $(this) }); });
        $('.js-reset-password').each(function() { new UserResetPasswordView({ el: $(this) }); });
    }

    if(document.querySelector(".js-deal")){
        new DealView();
    }

    JSErrorTracking.setMetaData('backboneRunning', true);
    
});
